import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
/* eslint-disable @typescript-eslint/no-var-requires */
const backgroundImagePath = require('./confetti-illo-bg.svg').default;

@Component({
  selector: 'mode-confetti-layout',
  templateUrl: './confetti-layout.component.html',
  styleUrls: ['./confetti-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfettiLayoutComponent {
  backgroundStyle: SafeStyle = this.sanitizer.bypassSecurityTrustStyle(`background-image: url(${backgroundImagePath})`);

  constructor(private sanitizer: DomSanitizer) {}
}
